import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Flex from 'components/common/Flex';
import WizardForm from 'components/wizard/Wizard';

const FormTitle = ({ title }) => (
  <Flex className="align-items-center justify-content-center w-100">
    <h5 className="mb-0" style={{ color: '#333' }}>
      {title}
    </h5>
  </Flex>
);

FormTitle.propTypes = {
  title: PropTypes.string.isRequired
};

const UserFormPage = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const isEditMode = !!userId;

  return (
    <>
      <Row className="align-items-center mt-3 mb-3">
        <Col xs="auto">
          <Button
            variant="light"
            size="sm"
            onClick={() => navigate(-1)}
            style={{
              border: '1px solid #ccc',
              color: '#333',
              padding: '0.25rem 0.75rem',
              fontWeight: 'normal',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem'
            }}
            aria-label="Go Back"
          >
            {/* Left arrow unicode character */}
            <span style={{ fontSize: '1.1rem' }}>←</span>
            Go Back
          </Button>
        </Col>
        <Col className="text-center">
          <FormTitle 
            title={isEditMode ? "Edit User Profile" : "Add User Profile"} 
          />
        </Col>
        <Col xs="auto" /> {/* Empty column to balance layout */}
      </Row>
      <Row>
        <Col lg={6} xl={12} xxl={6}>
          <WizardForm variant="pills" userId={userId} isEditMode={isEditMode} />
        </Col>
      </Row>
    </>
  );
};

export default UserFormPage;
